/**
 * Shared signup field checks used by the Auth UI.
 * Keep in sync with auth-api register validation.
 */

export function isValidEmailAddress(email: string): boolean {
  const trimmed = email.trim();
  if (!trimmed) return false;
  // Require a single @ with non-empty local + domain parts (e.g. a@b).
  const at = trimmed.indexOf("@");
  if (at <= 0 || at !== trimmed.lastIndexOf("@")) return false;
  const domain = trimmed.slice(at + 1);
  return domain.length > 0 && !domain.includes(" ");
}

export function isValidPersonName(name: string): boolean {
  const trimmed = name.trim();
  if (!trimmed) return false;
  // Names are not emails — reject @ (and other common email-ish typos).
  if (trimmed.includes("@")) return false;
  return true;
}

export function validateSignupEmail(email: string): string | null {
  if (!isValidEmailAddress(email)) {
    return "Please enter a valid email address";
  }
  return null;
}

export function validateSignupName(
  firstname: string,
  lastname: string
): string | null {
  if (!isValidPersonName(firstname) || !isValidPersonName(lastname)) {
    return "Please enter a valid first and last name (names cannot contain @)";
  }
  return null;
}
